// conditions for bot..

// levels to show opt in prompt
export const OptInLevelTriggers: number[] = [3, 7];

// show again after x level attempts

// time limit between prompts after x levels

// time limit on rewards for subscribing
export const OptInRewardLimit: number = convertFromDays(2);

// rewards
export function convertToDays(ms: number): number {
    return ms / 24 / 60 / 60 / 1000;
}

export function convertFromDays(d: number): number {
    return d * 24 * 60 * 60 * 1000;
}
